module.exports = __webpack_public_path__ + "img/av-hover.0b467511.png";